import {Stack, Heading, Text, Inline, usePatronTheme} from "@unibuddy/patron";
import RelativeLink from "ubcommunity-shared/src/Navigation/RelativeLink/RelativeLink";
import {boldFontStyles} from "ubcommunity-shared/src/Styles/fontStyles";
import {Routes, Auth} from "ubcommunity-shared/src/constants";

export function RegisterHeader({invitedEmail}: {invitedEmail?: string}) {
    const theme = usePatronTheme();

    return (
        <Stack space="medium" align="center">
            <Text align="center">Create your account {invitedEmail ? "for" : null}</Text>
            {invitedEmail ? (
                <Heading level="1" size="xsmall">
                    {invitedEmail}
                </Heading>
            ) : null}
            <Inline verticalAlign="center" space="xxsmall">
                <Text nowrap size="small">
                    Have an account?
                </Text>
                <RelativeLink to={Routes.LOGIN}>
                    <Text
                        size="small"
                        color={theme?.colors?.textLinkColor}
                        // @ts-ignore
                        style={{
                            ...boldFontStyles,
                            textDecorationLine: "underline",
                            textDecorationColor: theme?.colors?.textLinkColor,
                        }}
                    >
                        {Auth.PRIMARY_CTA}
                    </Text>
                </RelativeLink>
            </Inline>
        </Stack>
    );
}
